<script setup lang="ts">
</script>

<template>
  <div class="card animate-pulse flex flex-col md:flex-row md:items-center gap-4" role="status" aria-live="polite">
    <span class="sr-only">Loading...</span>
    <!-- Status badge -->
    <div class="md:w-32 text-center md:text-left">
      <div class="h-6 bg-gray-700 rounded w-20 inline-block"></div>
    </div>

    <!-- Event info -->
    <div class="flex-1">
      <div class="h-6 bg-gray-700 rounded w-48 mb-2"></div>
      <div class="h-5 bg-gray-700 rounded w-64 mb-2"></div>
      <div class="h-4 bg-gray-700 rounded w-56"></div>
    </div>

    <!-- Date -->
    <div class="text-center md:text-right">
      <div class="h-5 bg-gray-700 rounded w-32"></div>
    </div>
  </div>
</template>
